import { create } from 'zustand';
import api from '@/services/api';

/* ─── Types ──────────────────────────────────── */
export interface Badge {
  badge_id: string;
  name: string;
  description: string;
  icon: string;
  category: string;
  xp_reward: number;
  earned: boolean;
  earned_at: string | null;
}

export interface UserLevel {
  total_xp: number;
  level: number;
  level_name: string;
  next_level_xp: number;
  progress: number;
  rank?: number;
}

interface GamificationState {
  badges: Badge[];
  level: UserLevel | null;
  isLoading: boolean;

  fetchBadges: () => Promise<void>;
  fetchLevel: () => Promise<void>;
  checkBadges: () => Promise<Badge[]>;
}

export const useGamificationStore = create<GamificationState>((set) => ({
  badges: [],
  level: null,
  isLoading: false,

  fetchBadges: async () => {
    set({ isLoading: true });
    try {
      const { data } = await api.get('/gamification/badges');
      set({ badges: data.badges ?? [] });
    } catch {
      // silent
    } finally {
      set({ isLoading: false });
    }
  },

  fetchLevel: async () => {
    try {
      const { data } = await api.get('/gamification/level');
      set({ level: data });
    } catch {
      // silent
    }
  },

  checkBadges: async () => {
    try {
      const { data } = await api.post('/gamification/check');
      if (data.level) set({ level: data.level });
      return data.new_badges ?? [];
    } catch {
      return [];
    }
  },
}));
